import { useQuery } from 'react-query';

import { GetSubsetOverviewResponseDto } from '../../../../backend/src/matter/subset/dto/get-subset-overview.response.dto';
import { QueryEntity } from '../types';
import { APIBaseChronos } from '@/api/hosts';
import { useFetcher } from '@/api/useGetFetchConfig';

const PROCESSING_POLL_INTERVAL = 3000;

export const useGetSubsetOverview = (matterId?: string, subsetId?: string, options?: { isProcessing?: boolean }) => {
  const fetcher = useFetcher();

  const getSubsetOverview = (): Promise<GetSubsetOverviewResponseDto> =>
    fetcher(`${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/overview`);

  return useQuery([QueryEntity.SubsetOverview, { subsetId }], getSubsetOverview, {
    enabled: !!matterId && !!subsetId,
    refetchOnWindowFocus: false,
    refetchInterval: options?.isProcessing ? PROCESSING_POLL_INTERVAL : false,
  });
};
